const Textarea = {
  variants: {
    normal: {
      border: '1px solid',
      borderColor: 'gray.200',
      borderRadius: 0,
      resize: 'none',
    },
  },
  defaultProps: {
    variant: 'normal',
  },
};

export default Textarea;
